let address1Field: HTMLInputElement;
let address2Field: HTMLInputElement;
let townField: HTMLInputElement;
let countyField: HTMLInputElement;
let countryField: HTMLSelectElement;
let postalField: HTMLInputElement;

export default async function (): Promise<void> {
    // @ts-expect-error
    const { PlaceAutocompleteElement } = await google.maps.importLibrary('places');
    const placeAutocomplete = new PlaceAutocompleteElement({
        includedPrimaryTypes: ['postal_code'],
        includedRegionCodes: ['GB', 'IE'],
    });

    let autocomplete = document.getElementById('js-address-autocomplete-search') as HTMLDivElement;
    autocomplete.appendChild(placeAutocomplete);

    placeAutocomplete.addEventListener("gmp-select", fillInAddress);
}

async function fillInAddress({ placePrediction }): Promise<void> {
    address1Field = document.querySelector(".js-address-autocomplete-address-line-1") as HTMLInputElement;
    address2Field = document.querySelector(".js-address-autocomplete-address-line-2") as HTMLInputElement;
    townField = document.querySelector(".js-address-autocomplete-town") as HTMLInputElement;
    countyField = document.querySelector(".js-address-autocomplete-county") as HTMLInputElement;
    countryField = document.querySelector(".js-address-autocomplete-country") as HTMLSelectElement;
    postalField = document.querySelector(".js-address-autocomplete-postcode") as HTMLInputElement;

    // Get the place details from the autocomplete object.
    const place = placePrediction.toPlace();
    await place.fetchFields({
        fields: ['addressComponents'],
    });

    let address1 = "";
    let address2 = "";
    let postcode = "";
    let town = "";
    let county = "";
    let country = "";

    // @ts-expect-error - when this gets addressed also remove the global eslint-disables above
    for (const component of place.addressComponents as google.maps.places.AddressComponent[]) {
        const componentType = component.types[0];

        switch (componentType) {
            case "street_number":
                address1 = `${component.longText} ${address1}`;
                break;
            case "route":
                address1 += component.longText;
                break;
            case "postal_code":
                postcode = `${component.longText}${postcode}`;
                break;
            case "postal_code_suffix":
                postcode = `${postcode}-${component.longText}`;
                break;
            case "neighborhood":
                address2 = component.longText;
                break;
            case "postal_town":
                town = component.longText;
                break;
            case "administrative_area_level_2":
                county = component.longText;
                break;
            case "administrative_area_level_1":
                if (county === "") {
                    county = component.longText;
                }
                break;
            case "country":
                country = component.shortText;
                break;
        }
    }

    address1Field.value = address1;
    address2Field.value = address2;
    postalField.value = postcode;
    townField.value = town;
    countyField.value = county;
    countryField.value = country;

    address1Field.focus();
}
